import React, { useContext, useState } from "react";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import IntegrationSteps from "./tabContent/IntegrationSteps";
import Tabs from "@material-ui/core/Tabs";
import TabPanel from "../elements/tab/materialTabPanel";
import Tab from "@material-ui/core/Tab";
import { useTranslation } from "react-i18next";
import Can from "../can/Can";

import {
  StyledHeadLinks,
  StyledSeparator,
  StyledTabLink,
  StyledTabsBody,
  StyledTabsHead,
  StyledTabsWrapper
} from "../styles/styledTabs";
import { StyledHomeWrapper } from "./styledHome";
import { navbar } from "../../rbac-consts";
import { AppContext } from "../../App";

const Home = () => {
  const { t } = useTranslation("homePage");
  const { user } = useContext(AppContext);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <StyledHomeWrapper>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledTabsWrapper>
        <StyledTabsHead className="tab-head">
          <h4 className="tab-head__title">
            {t("tabs.title")}
          </h4>
          <Tabs
            value={value}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="vertical"
            className="tab-head-buttons"
          >
            <Tab
              label={t("tabs.mainInfo")}
            />
            {/*<Tab
              label="Уровни доступов"
            />*/}
            {/*<Tab
              label="Где найти ключи"
            />*/}
          </Tabs>
          <StyledSeparator />
          <StyledHeadLinks>
            <StyledTabLink
              as="a"
              href="/api/introduction"
              target="_blank"
              className="tab-head__link"
            >
              {t("tabs.introduction")}
            </StyledTabLink>
            <StyledTabLink
              as="a"
              href="/api/docs"
              target="_blank"
              className="tab-head__link"
            >
              Swagger
            </StyledTabLink>
            <Can
              role={user.roles}
              perform={navbar.SERVICES}
              yes={() => (
            <StyledTabLink
              as={NavLink}
              to="/services"
              className="tab-head__link"
            >
              {t("tabs.service")}
            </StyledTabLink>
              )}
            />
            <StyledTabLink
              as={NavLink}
              to="/account"
              className="tab-head__link"
            >
              {t("tabs.account")}
            </StyledTabLink>

          </StyledHeadLinks>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={value}
            index={0}
          >
            <IntegrationSteps />
          </TabPanel>
          {/*<TabPanel
            value={value}
            index={1}
          >
            <AccessLevels />
          </TabPanel>*/}
          {/*<TabPanel
            value={value}
            index={2}
          >
            <FindTheKeys />
          </TabPanel>*/}
        </StyledTabsBody>
      </StyledTabsWrapper>
    </StyledHomeWrapper>
  );
};

export default Home;
